import { useEffect } from 'react';

/** Clears a banner after `delayMs`. Success: 5000, failure: 10000. */
export function useAutoClear(
  value: string | null,
  setValue: (next: string | null) => void,
  delayMs: number,
) {
  useEffect(() => {
    if (!value) return undefined;
    const timer = window.setTimeout(() => setValue(null), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs, setValue]);
}
